module.exports = __webpack_public_path__ + "static/media/gradient-yellow.a9785db7.svg";